export const LOGGEDIN_USER_INFO = 'LOGGEDIN_USER_INFO';
export const REMOVE_USER_INFO = 'REMOVE_USER_INFO';